import { render, staticRenderFns } from "./PaymentBreakdown.vue?vue&type=template&id=4f23d42c&scoped=true&"
import script from "./PaymentBreakdown.vue?vue&type=script&lang=js&"
export * from "./PaymentBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBreakdown.vue?vue&type=style&index=0&id=4f23d42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f23d42c",
  null
  
)

export default component.exports